import { useSelector } from "react-redux"
import { Wrapper, FirstBlock, SecondBlock, ThirdBlock, ImageWrapper, Image, FirstTextBox, SecondTextBox, Heading, BodyText, WhoWeAre, HeadingCapital, BodyTextLastBlock, FindOutMore } from "./HomeSection2Style"
import student from "./01_images/student.jpg"
import tutor from "./01_images/tutor.jpg"
import English from "./02_content/English"
import Ukrainian from "./02_content/Ukrainian"
import { home } from "../../../i18n/02_home"


const HomeSection2 = () => {

  const lang =  useSelector(state => state.lang.lang)

  const t = home[lang]

  return (
    <Wrapper>
      <FirstBlock>
        <ImageWrapper>
          <Image src={student} />
        </ImageWrapper>
        <FirstTextBox>
          <HeadingCapital>{t.two_heading_cap1}</HeadingCapital>
          <BodyText>{t.two_body_text1}</BodyText>
        </FirstTextBox>
      </FirstBlock>
      <SecondBlock>
        <ImageWrapper>
          <Image src={tutor} />
        </ImageWrapper>
        <SecondTextBox>
          <HeadingCapital>{t.two_heading_cap2}</HeadingCapital>
          <BodyText>{t.two_body_text2}</BodyText>
        </SecondTextBox>
      </SecondBlock>
      <ThirdBlock>
        <WhoWeAre>{t.two_who_we_are}</WhoWeAre>
        <Heading>{t.two_heading_who}</Heading>
        <BodyTextLastBlock>
          {t.two_body_text_who1}
        </BodyTextLastBlock>
        <BodyTextLastBlock>
          {t.two_body_text_who2}
        </BodyTextLastBlock>
        <FindOutMore to='./about'>{t.two_find_out}</FindOutMore>
      </ThirdBlock>
    </Wrapper>
  )
}


export default HomeSection2
